import {
  rentersPolicyAvailable,
  standaloneRentersStates,
  condoStates,
  policyType,
  lookupsJson
} from '@ourbranch/lookups';
import { isPolicyTypeEnabled } from 'common/helpers/environment-helpers';
import { isFarmPolicyTypeLive } from 'common/helpers/farm-helpers';

const useAvailablePolicies = (state) => {
  if (!state) {
    return lookupsJson.policyTypes.filter((opt) => isPolicyTypeEnabled(opt.id) && isFarmPolicyTypeLive(opt.id, state));
  }
  const isRentersAvailable = rentersPolicyAvailable[state];
  const isStandaloneRentersAvailable = standaloneRentersStates[state];
  const isCondoAvailable = condoStates[state];

  return lookupsJson.policyTypes.filter((opt) => {
    if (!isPolicyTypeEnabled(opt.id)) {
      return false;
    }

    // Home (Z) / Rental (Y) only appear where their policyTypeMask is present (#31043, #31219).
    // Forreston has launched both in every environment; other carriers may still strip the mask
    // in production pre-launch, and this check honors that automatically.
    // Gate on env-level liveness (any configured farm state), NOT the mailing-address `state`:
    // the property may be in IL while the named insured's mailing address is elsewhere (e.g. an
    // out-of-state landlord). The IL restriction is enforced on the farm LOCATION (risk) address
    // at form validation instead of by hiding the option here. (#32037)
    if (!isFarmPolicyTypeLive(opt.id)) {
      return false;
    }

    // Apply state-based availability rules for Condo and Renters
    if (opt.id.includes(policyType.Condo)) {
      return isCondoAvailable;
    }
    if (opt.id === policyType.ARBundle) {
      return isRentersAvailable;
    }
    if (opt.id === policyType.Renters) {
      return isStandaloneRentersAvailable;
    }

    return true;
  });
};

export default useAvailablePolicies;
